var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.03125H18V10.9688H0V7.03125Z",
    fill: "#EC1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 2.8125H2.8125C0.948656 2.8125 0 4.19766 0 5.90625V7.03125H18V5.90625C18 4.19766 17.0513 2.8125 15.1875 2.8125Z",
    fill: "#25333A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0938C0 13.8023 0.948656 15.1875 2.8125 15.1875H15.1875C17.0513 15.1875 18 13.8023 18 12.0938V10.9688H0V12.0938Z",
    fill: "#F9CB38"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGermany);
export default __webpack_public_path__ + "static/media/flag-germany.ecad93b5511a9930b9fc1322e0181934.svg";
export { ForwardRef as ReactComponent };